import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useRef, useState } from "react";
import StatusBadge from "components/StatusBadge";
import Popper from "components/Popper";
import StatusModal from "components/StatusModal";
import { IStatus } from "dto/IStatus";
import { ItemKind } from "dto/IKindItems";
import { Tooltip } from "@mui/material";

const StatusCell: FC<Props> = ({ element, statuses }) => {
  const refStatus = useRef(null);

  const [showStatus, setShowStatus] = useState<boolean>(false);
  const [status, setStatus] = useState<IStatus>(
    statuses.find((s) => s.Id === element.StatusId)
  );

  const handleStatusUpdate = (status?: IStatus) => {
    setStatus(status);
    setShowStatus(false);
  };

  return (
    <div className={styles.status}>
      {element.StatusId && (
        <div
          ref={refStatus}
          className={styles.badge}
          onClick={(e) => {
            setShowStatus(!showStatus);
            e.stopPropagation();
          }}
        >
          {status && <StatusBadge status={status} showName={true} />}
        </div>
      )}
      {!element.StatusId && (
        <Tooltip title="Ustaw status">
          <div>
            <div
              ref={refStatus}
              className={styles.fakeBadge}
              onClick={(e) => {
                setShowStatus(!showStatus);
                e.stopPropagation();
              }}
            >
              ...
            </div>
          </div>
        </Tooltip>
      )}

      {showStatus && (
        <Popper
          anchorEl={refStatus?.current}
          open={showStatus}
          setOpen={setShowStatus}
        >
          <StatusModal
            item={{
              Id: element?.Id,
              Kind: ItemKind.LegalPerson,
              StatusId: element.StatusId,
            }}
            toggle={setShowStatus}
            selectedStatus={status}
            afterUpdate={handleStatusUpdate}
          />
        </Popper>
      )}
    </div>
  );
};

export default StatusCell;
